<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  text-align: center;
}
html, body {margin: 0; height: 100%; overflow: hidden}
</style>
